import { useContext, useState } from 'react';
import { useDeleteProfileEntry } from '../../../hooks/useDeleteProfileEntry';
import ProfileMainSection from '../../ResumeSection';
import PastExamsCard from './PastExamsCard';
import PastExamsForm from './PastExamsForm';
import StepBanner from '@modules/Account/Profile/components/ProfileBanner/StepBanner';
import SkeletonBox from '@components/V4/SkeletonBox';
import { ProfileContext } from '../../../AccountProfile';
import { UserExamWithName } from '@shared/clientTypes/DTOs/UserDTO';

interface PastExamsSectionProps {
  exams: UserExamWithName[];
  userId: string;
}

const PastExamsSection = (props: PastExamsSectionProps) => {
  const { exams, userId } = props;

  const { isLoading, isMentorViewer } = useContext(ProfileContext);

  const [isAddNewItem, setIsAddNewItem] = useState(false);

  const [deleteEntryHandler] = useDeleteProfileEntry({
    userId,
    profileProperty: 'exams',
  });

  const addNewItemCancelHandler = () => {
    setIsAddNewItem(false);
  };

  return (
    <ProfileMainSection
      title="Past Exams"
      onClick={() => setIsAddNewItem((prev) => !prev)}
      isButtonActive={isAddNewItem}
    >
      {isLoading ? (
        <SkeletonBox className="w-full h-[78px]" />
      ) : (
        <>
          {isAddNewItem && (
            <PastExamsForm
              userId={userId}
              isModeAddNew
              setIsAddNewItem={setIsAddNewItem}
              onCancel={addNewItemCancelHandler}
            />
          )}

          {!!exams.length &&
            exams.map((exam) => (
              <PastExamsCard
                key={exam._id}
                userId={userId}
                exam={exam}
                onDeleteEntry={deleteEntryHandler}
              />
            ))}

          {!isAddNewItem && !exams.length && !isMentorViewer && (
            <StepBanner stepOption={'missingExams'} onClick={() => setIsAddNewItem((prev) => !prev)} />
          )}
        </>
      )}
    </ProfileMainSection>
  );
};

export default PastExamsSection;
